<template>
  <div>
    <v-overlay :value="true">
      <v-progress-circular
        indeterminate
        size="64" />
    </v-overlay>
  </div>
</template>

<script>
import AuthProvider from '@/resources/AuthProvider'
import { mapActions } from 'vuex'
import { setAuthUser, clearAuth } from '@/assets/js/Authentication'

const authService = new AuthProvider()

export default {
  created () {
    setTimeout(() => {
      clearAuth()
      this.checkPage()
    }, 1000)
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar'
    }),
    async login (token) {
      try {
        const { accessToken } = await authService.login(token)
        const auth = setAuthUser(accessToken)
        if (auth) {
          this.setSnackBar({
            value: true,
            message: 'Login Success',
            type: 'success'
          })
          this.$router.push({ name: 'Home' })
        } else {
          throw new Error()
        }
      } catch (error) {
        this.setSnackBar({
          value: true,
          message: 'Something went wrong Please reload the page',
          type: 'error'
        })
        console.error('login', error)
      }
    },
    checkLogin () {
      const { query } = this.$route
      if (query && query.token_reference) {
        this.login(query.token_reference)
      } else {
        setTimeout(() => {
          const uri = `${window.location.origin}${this.$route.path}`
          window.location.replace(`${process.env.VUE_APP_LOGIN}?callback_uri=${encodeURI(uri)}`)
        }, 1000)
      }
    },
    checkPage () {
      if (this.$route.name === 'Logout') {
        this.$router.replace({ name: 'Login' })
      } else {
        this.checkLogin()
      }
    }
  }
}
</script>
